import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (error, reject) => reject(error);

export default (newsId, type, dates) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`news/${newsId}/${type}/${dates}/email-trackings`)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/news/newsEmailTrackings.js